import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import { useDispatch } from "react-redux";
import { deleteDiscountTimeRangeService, getDiscountTimestampRangeService } from "redux/services/products_sevice";
import { toast } from "react-toastify";

const DeleteDiscountModal = ({ isOpen, onClose, onConfirm }) => {
  const dispatch = useDispatch();

  const { t } = useTranslation();
  const [isProcessing, setIsProcessing] = useState(false);

  if (!isOpen) return null;

  const handleConfirm = async () => {
    setIsProcessing(true);
    try {
      await onConfirm();
      dispatch(deleteDiscountTimeRangeService()).then((response) => {
        if (response.payload.status == 200) {
          toast("تم الحذف بنجاح ");
          dispatch(getDiscountTimestampRangeService())
          onClose();
        }
      });
    } catch (error) {
      console.error("Delete failed:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[100] transition-all">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 overflow-hidden border border-border">
        {/* Header */}
        <div className="flex items-center justify-between p-5 border-b border-gray-100">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-red-50 flex items-center justify-center">
              <Icon name="AlertTriangle" size={22} className="text-red-600" />
            </div>
            <div>
              <h2 className="text-lg font-bold text-gray-900">
                إلغاء فترة الخصم
              </h2>
              <p className="text-xs text-muted-foreground">
                إجراء حساس يتطلب التأكيد
              </p>
            </div>
          </div>

          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}
            disabled={isProcessing}
            className="rounded-full hover:bg-gray-100"
          >
            <Icon name="X" size={18} />
          </Button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          <div className="bg-red-50/50 border border-red-100 rounded-xl p-4">
            <div className="flex items-start gap-3">
              <Icon
                name="Info"
                size={20}
                className="text-red-500 flex-shrink-0 mt-0.5"
              />
              <div className="space-y-1">
                <p className="text-sm font-medium text-red-900">
                  هل أنت متأكد من حذف تاريخ الخصومات؟
                </p>
                <p className="text-xs text-red-700/80 leading-relaxed">
                  سيتم إزالة العروض الترويجية عن كافة المنتجات المرتبطة بهذا
                  التاريخ فوراً. هذا الإجراء لا يمكن التراجع عنه.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-3 p-5 bg-gray-50/50 border-t border-gray-100">
          <Button
            variant="outline"
            onClick={onClose}
            disabled={isProcessing}
            className="border-gray-300 text-gray-700 hover:bg-white"
          >
            {t("cancel")}
          </Button>

          <Button
            variant="destructive"
            onClick={handleConfirm}
            disabled={isProcessing}
            loading={isProcessing}
            className="bg-red-600 hover:bg-red-700 text-white shadow-sm shadow-red-200"
            iconName="Trash2"
            iconPosition="left"
          >
            تأكيد الحذف
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteDiscountModal;
